(function () {
    if (window.__shopBySpacesHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.shopBySpaces = window.Branch.shopBySpaces || {};
    window.Branch.shopBySpaces.sliders = window.Branch.shopBySpaces.sliders || {};

    window.__shopBySpacesHasFired = true;
    
    const shopBySpacesHeroSettings = {
        classes: {
            clickableLinkDotClass: 'shop-by-spaces-hero__clickable-link-dot'
        },
        selectors: {
            clickableLinkDotSelector: '.shop-by-spaces-hero__clickable-link-dot',
            clickableLinksContainerSelector: ".shop-by-spaces-hero__clickable-links-container",
            shopBySpacesHeroSelector: ".shop-by-spaces-hero"
        },
        specs: {
            dotTextDescription: 'bold 10px Quicksand, sans-serif'
        }
    }

    const spacesResizeDebounce = function(func){
        var timer;
        return function(event){
          if(timer) clearTimeout(timer);
          timer = setTimeout(func,500,event);
        };
      }

    let newTab = true;
    const shopBySpacesHero = document.querySelector(`${shopBySpacesHeroSettings.selectors.shopBySpacesHeroSelector}:not(.shopify-section)`);
    if(shopBySpacesHero){
        newTab = shopBySpacesHero.getAttribute('data-open-links-in-new-tab') == "true";
    }

    const calcTextWidth = function(text, font) {
        const canvas = calcTextWidth.canvas || (calcTextWidth.canvas = document.createElement("canvas"));
        const context = canvas.getContext("2d");
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
      }

    const insertText = function(dot){
        let text = `Featured: <a href="${dot.getAttribute('data-product-url')}" ${newTab && 'target="_blank"'}>${dot.getAttribute('data-product-title')}</a>`;
        dot.innerHTML = text;
    }

    const modifyDotDimensions = function(dot, dots, status){
        dots.forEach((singleDot) => {
            singleDot.setAttribute('style', '');
            singleDot.innerHTML = '';
        });
        if(dot){
            let textWidth = 1.13 * (calcTextWidth(`Featured: ${dot.getAttribute('data-product-title')}`, shopBySpacesHeroSettings.specs.dotTextDescription));
            let percentageAcross = parseInt(dot.getAttribute('data-position-percentage-across'));
            if(status){
                let newStyling = percentageAcross > 50 ? `right: calc(${100 - percentageAcross}% - 24px); left: calc(${percentageAcross}% - ${textWidth + 16}px + 24px); width: ${textWidth + 16}px` : `width: ${textWidth + 16}px`;
                dot.setAttribute('style', newStyling);
                insertText(dot);
            
            } else {
                dot.style.width = '24px'
            }
        }
    }

    const modifyProductCard = function(dot, dots, status){
        let allProductCards = dots[0].closest('.shop-by-spaces-hero').querySelectorAll(`.shop-by-spaces-hero__clickable-link-product`);
        let allProductTriangles = dots[0].closest('.shop-by-spaces-hero').querySelectorAll(`.shop-by-spaces-hero__clickable-link-product-triangle`);
        let allDots = dots[0].closest('.shop-by-spaces-hero').querySelectorAll(`.shop-by-spaces-hero__clickable-link-dot`);
        if(dot){
            let dotIndex = dot.getAttribute('data-index');
            allProductCards = dots[0].closest('.shop-by-spaces-hero').querySelectorAll(`.shop-by-spaces-hero__clickable-link-product:not([data-index="${dotIndex}"])`);
            allProductTriangles = dots[0].closest('.shop-by-spaces-hero').querySelectorAll(`.shop-by-spaces-hero__clickable-link-product-triangle:not([data-index="${dotIndex}"])`);
            allDots = dots[0].closest('.shop-by-spaces-hero').querySelectorAll(`.shop-by-spaces-hero__clickable-link-dot:not([data-index="${dotIndex}"])`);
        }
       
        allProductCards.forEach((productCard) => {
            productCard.setAttribute('style', 'opacity: 0; pointer-events: none; visibility: visible;');
        });
        allProductTriangles.forEach((productTriangle) => {
            productTriangle.setAttribute('style', 'opacity: 0; pointer-events: none; visibility: visible;');
        });
        allDots.forEach((singleDot) => {
            singleDot.setAttribute('style', 'background-color: var(--primary-green); border-color: var(--primary-green); pointer-events: none;');
            setTimeout(() => {
                singleDot.setAttribute('style', 'background-color: var(--primary-green); border-color: var(--primary-green);');
              }, 100);
        })
        if(dot){
            if(status){
                dot.closest('.shop-by-spaces-hero__clickable-link').querySelector('.shop-by-spaces-hero__clickable-link-product-triangle').setAttribute('style', 'visibility: visible; opacity: 1;');
                dot.closest('.shop-by-spaces-hero__clickable-link').querySelector('.shop-by-spaces-hero__clickable-link-product').setAttribute('style', 'visibility: visible; opacity: 1; pointer-events: all;');
                dot.setAttribute('style', 'background-color: var(--primary-blue); border-color: var(--primary-blue);');
            } else {
                dot.closest('.shop-by-spaces-hero__clickable-link').querySelector('.shop-by-spaces-hero__clickable-link-product-triangle').setAttribute('style', 'opacity: 0; pointer-events: none; visibility: visible;');
                dot.closest('.shop-by-spaces-hero__clickable-link').querySelector('.shop-by-spaces-hero__clickable-link-product').setAttribute('style', 'opacity: 0; pointer-events: none; visibility: visible;');
                dot.setAttribute('style', 'background-color: var(--primary-green); border-color: var(--primary-green); pointer-events: none;');
                setTimeout(() => {
                    // dot.closest('.shop-by-spaces-hero__clickable-link').querySelector('.shop-by-spaces-hero__clickable-link-product-triangle').setAttribute('style', 'visibility: hidden; opacity: 0;');
                    // dot.closest('.shop-by-spaces-hero__clickable-link').querySelector('.shop-by-spaces-hero__clickable-link-product').setAttribute('style', 'visibility: hidden; opacity: 0;');
                    dot.setAttribute('style', 'background-color: var(--primary-green); border-color: var(--primary-green);');
                  }, 100);
            }
        }
    }

    const handleDotEvent = function(event, dot, dots){
        let status;
        if(event !== "click outside"){
            status = !(dot.getAttribute('data-showing') === "true");
        }
      
        dots.forEach((singleDot) => { 
            (singleDot.setAttribute('data-showing', false));
            (singleDot.setAttribute('data-transitioning', true));
            setTimeout(() => {
                (singleDot.setAttribute('data-transitioning', false));
              }, 40);
              
        });
        if(event !== "click outside"){
            dot.setAttribute('data-showing', status);
            modifyProductCard(dot, dots, status);
        } else {
            modifyProductCard(null, dots, null);
        }
    }

    const handleProductCardHover = function(event, productCard){
        let hover = event == 'mouseenter' ? true : false;
        let clickableLink = productCard.closest('.shop-by-spaces-hero__clickable-link');
        clickableLink.setAttribute('data-product-card-hover', hover)
    }

    const onClickOutside = function(e, dots, index, imageInnerContainer) {
        let isClickedOutside = true;
        if(e.target.className.includes(shopBySpacesHeroSettings.classes.clickableLinkDotClass)  || e.target.className.includes('.shop-by-spaces-hero__clickable-link-product') || e.target.closest('.shop-by-spaces-hero__clickable-link-product')){
            isClickedOutside = false
        }
        if (isClickedOutside) {
            handleDotEvent('click outside', null, dots);
            let linkUrl = imageInnerContainer.getAttribute('data-link-url');
            if(linkUrl){
                window.open(`/pages/${linkUrl}`, '_blank');
            }
        }
      };

    const initDotHoverFocusEvent = function(shopBySpacesHeroSection){
        let dots = shopBySpacesHeroSection.querySelectorAll(`${shopBySpacesHeroSettings.selectors.clickableLinkDotSelector}`);
        let imageInnerContainers = shopBySpacesHeroSection.querySelectorAll(`${shopBySpacesHeroSettings.selectors.clickableLinksContainerSelector}`)
        let linkUrl = `/pages/${imageInnerContainers[0].getAttribute('data-link-url')}`;

        if(imageInnerContainers && imageInnerContainers.length > 0){
            imageInnerContainers.forEach((imageInnerContainer, index) => {
                imageInnerContainer.addEventListener("click", function(e){
                    onClickOutside(e, dots, index, imageInnerContainer)
                });
            })
        }

        if(dots.length > 0){
            dots.forEach((dot) => {
                    dot.addEventListener('click', (e) => {
                        handleDotEvent('click', dot, dots)
                    });
            })
        }
    }

    const initShopBySpacesSlider = function(event, shopBySpacesHeroSection, parentId) {
        let params = {};
        var menu = [];
        let autoplay = false;
        let slideAmount = parseInt(shopBySpacesHeroSection.querySelector(".shop-by-spaces-hero__slider").getAttribute('data-slides'));
        if(shopBySpacesHeroSection.querySelector(".shop-by-spaces-hero__slider").getAttribute('data-autoplay') == "true"){
            autoplay = {
                delay: shopBySpacesHeroSection.querySelector(".shop-by-spaces-hero__slider").getAttribute('data-autoplay-delay') * 1000,
                disableOnInteraction: false
            }
        };
        shopBySpacesHeroSection.querySelectorAll('.swiper-slide').forEach((slide) => {
            menu.push(slide.getAttribute('data-text'));
        });
        if(event == "load"){
                params = {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    freeMode: false,
                    autoplay: autoplay,
                    direction: 'horizontal',
                    scrollbar: {
                        el: `#${parentId} .shop-by-spaces-hero__container .swiper-scrollbar`,
                        hide: true,
                        horizontalClass: 'swiper-scrollbar-horizontal'
                      },
                      pagination: {
                        el: `#${parentId} .shop-by-spaces-hero__swiper-scrollbar-inner-container .swiper-pagination`,
                        clickable: true,
                        renderBullet: function (index, className) {
                        return `<button class="shop-by-spaces-hero__tabs-button ${className}" 
                                data-index="${index}" 
                                data-animate-slide-in="true" 
                                data-cascade-order="${index + 2}">
                                <span>${menu[index]}</span>
                            </button>`;                          },
                      },
                        on: {
                            slideChangeTransitionStart: function () {
                                shopBySpacesHeroSection.setAttribute('data-index-selected', this.activeIndex)
                                updateTabsPosition(shopBySpacesHeroSection)
                            }
                    }
                }
        }
        if(slideAmount > 1){
                window.Branch.shopBySpaces.sliders[`${parentId}`] = new Swiper(`#${parentId} .shop-by-spaces-hero__slider`, params);
                  window.addEventListener("resize", spacesResizeDebounce(() => {
                    window.Branch.shopBySpaces.sliders[`${parentId}`].update();
                    window.Branch.shopBySpaces.sliders[`${parentId}`].slideTo(0)
                    }));
            } else {
                shopBySpacesHeroSection.querySelector('.swiper-pagination').innerHTML = `<span class="swiper-pagination-bullet">${menu[0]}</span>`
            }
    }

    function initSwipeOnTabsCarousel(shopBySpacesHeroSection){
    let element = shopBySpacesHeroSection.querySelector('.shop-by-spaces-hero__nav-tabs'); 
    let startX = 0;
    let isTouch = false;
    function handleStart(event) {
        isTouch = event.type === 'touchstart';
        startX = isTouch ? event.touches[0].clientX : event.clientX;
    }

    function handleEnd(event) {
        let endX = isTouch ? event.changedTouches[0].clientX : event.clientX;
        let deltaX = endX - startX;
        const SWIPE_THRESHOLD = 50;
        if (Math.abs(deltaX) >= SWIPE_THRESHOLD) {
            const direction = deltaX > 0 ? 'right' : 'left';
            handleShopBySpacesTabClick(null, direction, element);
        }
    }

    element.addEventListener('touchstart', handleStart, { passive: true });
    element.addEventListener('touchend', handleEnd, { passive: true });
    element.addEventListener('mousedown', handleStart);
    element.addEventListener('mouseup', handleEnd);
}

    function updateTabsPosition (container){
        let scrollBar = container.querySelector('.shop-by-spaces-hero__scrollbar');
        let scrollBarInner = container.querySelector('.shop-by-spaces-hero__scrollbar-inner');
        let buttons = Array.from(container.querySelectorAll('.shop-by-spaces-hero__tabs-button'));
        let index = parseInt(container.getAttribute('data-index-selected'));

        let currentTab = buttons[index];
        let swiper = container.querySelector('.swiper');

        // Swiper emits slideChangeTransitionStart during its own init, before renderBullet
        // has made the tabs, so the first call has no tab and no scrollbar to measure.
        if(!scrollBar || !scrollBarInner || !currentTab || !swiper) return;

        let totalWidth = buttons.reduce((total, el) => total + el.offsetWidth, 0);
        let totalPushOverWidth = buttons.slice(0, index).reduce((total, el) => total + el.offsetWidth, 0);
        let innerContainer = container.querySelector('.shop-by-spaces-hero__nav-tabs-inner-container');
        let differenceIncrements = (totalWidth - swiper.offsetWidth) / buttons.length

        if(container.getAttribute('data-tabs-carousel') == 'false'){
            // The tab's own box is measured rather than modelled: space-evenly spreads the slack as n+1 equal gaps, which no reconstruction of the layout got right.
            const barLeft = scrollBar.getBoundingClientRect().left;
            const tabBox = currentTab.getBoundingClientRect();
            scrollBarInner.style.left = `${tabBox.left - barLeft}px`;
            scrollBarInner.style.width = `${tabBox.width}px`;
        }

        if(container.getAttribute('data-tabs-carousel') == 'true'){
            scrollBarInner.style.left = `${totalPushOverWidth}px`;
            let extraToAdd = differenceIncrements * (index/(buttons.length - 1));
            let translateString = index == 0 ? `translateX(0)` : `translateX(-${(index * differenceIncrements) + extraToAdd}px)`;
            innerContainer.style.transform = translateString;
            scrollBar.style.transform = translateString;
            scrollBarInner.style.width = `${currentTab.offsetWidth}px`;
        }
    }

    function updateTabStyling(shopBySpacesHeroSection){
    let shopBySpaces = shopBySpacesHeroSection.querySelector('.shop-by-spaces-hero');
    if(shopBySpaces && shopBySpaces.querySelector('.shop-by-spaces-hero__slider') && parseInt(shopBySpaces.querySelector('.shop-by-spaces-hero__slider').getAttribute('data-slides')) > 1){
    
    let elementWidth = shopBySpaces.querySelector('.shop-by-spaces-hero__slider').offsetWidth;

      let tabSpans = shopBySpaces.querySelectorAll('.shop-by-spaces-hero__swiper-scrollbar-inner-container .swiper-pagination-bullet span');
      let underline = shopBySpaces.querySelector('.shop-by-spaces-hero__scrollbar');
      let totalWidthAllButtons = 0;
        tabSpans.forEach((tabSpan, index) => {
          tabSpan.closest('button').style.paddingLeft = 0;
          tabSpan.closest('button').style.paddingRight = 0;
          totalWidthAllButtons = totalWidthAllButtons + tabSpan.offsetWidth;
        })

    let widthsArray = Array.from(tabSpans).map(el => el.offsetWidth);
      totalWidthAllButtons = totalWidthAllButtons + ((tabSpans.length - 1) * (2 * 16));
      if(totalWidthAllButtons < elementWidth) {
        underline.style.width = '100%';
        shopBySpaces.setAttribute('data-tabs-carousel', false);
        shopBySpaces.querySelector('.shop-by-spaces-hero__nav-tabs-inner-container').style.transform = 'translateX(0)';

        // Equal shares so each label centres over its own stretch of line, but only where the WIDEST one fits its share — otherwise the natural widths stand.
        const share = elementWidth / tabSpans.length;
        const widest = Math.max(...widthsArray);
        const equalShares = widest <= share;

        tabSpans.forEach((tabSpan, index) => {
            tabSpan.closest('button').style.width = equalShares ? `${share}px` : `${widthsArray[index]}px`;
            tabSpan.closest('button').style.paddingLeft = 0;
            tabSpan.closest('button').style.paddingRight = 0;
        })
      } else {
        shopBySpaces.setAttribute('data-tabs-carousel', true);
        const isDesktop = window.matchMedia("(min-width: 901px)").matches;
        let padding = 0;
        if (isDesktop) {
          padding = 32;
        } else {
          padding = 16;
        }
        underline.style.width = `${totalWidthAllButtons + ((tabSpans.length - 1) * (2 * padding))}px`;
        tabSpans.forEach((tabSpan, index) => {
          if(index == 0){
            tabSpan.closest('button').style.width = `${widthsArray[index] + padding}px`;
            tabSpan.closest('button').style.paddingLeft = `${padding}px`;
            tabSpan.closest('button').style.paddingRight = `${padding}px`;
          } else if (index == (tabSpans.length - 1)) {
            tabSpan.closest('button').style.width = `${widthsArray[index] + padding}px`;
            tabSpan.closest('button').style.paddingLeft = `${padding}px`;
            tabSpan.closest('button').style.paddingRight = `${padding}px`;
          } else {
            tabSpan.closest('button').style.width = `${widthsArray[index] + (2 * padding)}px`;
            tabSpan.closest('button').style.paddingLeft = `${padding}px`;
            tabSpan.closest('button').style.paddingRight = `${padding}px`;
          }
        })
      }
      updateTabsPosition(shopBySpaces);
        shopBySpaces.querySelector('.shop-by-spaces-hero__swiper-scrollbar-inner-container').setAttribute('data-display-scrollbar', true);
        }
    }

    const updatePricingForShopBySpaces = function(shopBySpacesHeroSection){
        shopBySpacesHeroSection.querySelectorAll('.shop-by-spaces-hero__clickable-link-product-price:not(.shop-by-spaces-hero__clickable-link-product-price-original)').forEach((price) => {
          let handle = price.getAttribute('data-product-handle');
          let priceData = {};
          let productTile = price.closest('.shop-by-spaces-hero__clickable-link-product');
          let variantId = price.getAttribute('data-product-variant');
          let tileType = 'regular';

          window.Branch.collection.updateDisabledSwatchedPrice(productTile, priceData, tileType, handle, null, 'shopBySpaces');
        })
      }

    const renderShopBySpacesComposites = function(shopBySpacesHeroSection){
        if(!(window.Branch && window.Branch.compositeRenderImage && window.Branch.compositeRenderImage.renderProductComposite)) return;
        shopBySpacesHeroSection.querySelectorAll('.shop-by-spaces-hero__clickable-link-product-image-container[data-composite-render-product-id]').forEach((container) => {
            if(container.getAttribute('data-composite-rendered') === 'true') return;
            const productId = container.getAttribute('data-composite-render-product-id');
            let variant = null;
            let optionNames = null;
            try { variant = JSON.parse(container.getAttribute('data-composite-render-variant')); } catch(e){ return; }
            try { optionNames = JSON.parse(container.getAttribute('data-composite-render-option-names') || 'null'); } catch(e){ optionNames = null; }
            const rendered = window.Branch.compositeRenderImage.renderProductComposite(variant, productId, optionNames, container);
            if(rendered) container.setAttribute('data-composite-rendered', 'true');
        });
      }

    const calcHeroTextWidth = function(text, font) {
        const canvas = calcHeroTextWidth.canvas || (calcHeroTextWidth.canvas = document.createElement("canvas"));
        const context = canvas.getContext("2d");
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
      }

    const initHoverStyling = function(){
        let shopBySpacesStyling = document.querySelectorAll('style[shop-by-spaces-placement="true"]');
        if(shopBySpacesStyling.length > 0){
            shopBySpacesStyling.forEach((shopBySpacesStyle) => {
                shopBySpacesStyle.remove();
            })
        }
        let clickableLinkProducts = document.querySelectorAll('.shop-by-spaces-hero__clickable-link-product');
        clickableLinkProducts.forEach((clickableLinkProduct) => {
            let currentProductWidth = window.screen.width > 480 ? 300 : 250;
            if(window.screen.width > 840){currentProductWidth = 350};
            let currentFontSize = 16;
            let currentTextWidth = window.screen.width > 480 ? 160 : 110
            if(window.screen.width > 600 && window.screen.width < 841){
                currentFontSize = 18;
            } else if (window.screen.width > 840){
                currentFontSize = 20;
            }
            let textWidth = parseInt(1 + (calcHeroTextWidth(`${clickableLinkProduct.getAttribute('data-product-title')}`, `bold ${currentFontSize}px Quicksand, sans-serif`)));
        })
    }

    function handleShopBySpacesTabClick(e, direction, element){
    let button;
    if(e){
      e.preventDefault();
      button = e.target.closest('.shop-by-spaces-hero__tabs-button');
    } else {
      let currentButton = element.closest('.shop-by-spaces-hero').querySelectorAll(`.shop-by-spaces-hero__tabs-button`)[parseInt(element.closest('.shop-by-spaces-hero').getAttribute('data-index-selected'))];

      console.log('currentButton', currentButton)
      const sibling = direction === 'left' ? currentButton.nextElementSibling : currentButton.previousElementSibling;
      console.log('sibling', sibling, sibling.classList.contains('shop-by-spaces-hero__tabs-button'))
      button = sibling && sibling.classList.contains('shop-by-spaces-hero__tabs-button') ? sibling : currentButton;



    }
    if(button){
        let container = button.closest('.shop-by-spaces-hero');
        let indexSelected = button.getAttribute('data-index')
        if(!e){
            window.Branch.shopBySpaces.sliders[`${container.closest('.shopify-section').getAttribute('id')}`].slideTo(indexSelected);
        } else {
            //   let type = button.getAttribute('data-type');
            //   container.setAttribute('data-type-selected', type);
            container.setAttribute('data-index-selected', indexSelected);
            //   updateUnderlinePosition(container)
                updateTabsPosition(container)
            }
        }
    }


    const initshopBySpacesHero = function(shopBySpacesHeroSection, parent, type){
        let parentId = parent.getAttribute('id')
        let fromMetafieldSection = shopBySpacesHeroSection.querySelector('.shop-by-spaces-hero[data-from-metafield="true"]');
        let clickableLinksContainer = shopBySpacesHeroSection.querySelectorAll('.shop-by-spaces-hero__clickable-links-container');

        if(clickableLinksContainer.length > 0){
            initDotHoverFocusEvent(shopBySpacesHeroSection);
            initHoverStyling();
            window.addEventListener("resize", spacesResizeDebounce(() => {
            initHoverStyling();
            updateTabStyling(shopBySpacesHeroSection);
        }));
    }
        if(fromMetafieldSection){
            initShopBySpacesSlider("load", fromMetafieldSection, parentId);
        }

        function actionsOnVisible(shopBySpacesHeroSection){
            shopBySpacesHeroSection.setAttribute('data-interacted', true);
            window.Branch.nav.handleUpdateSrcSet(null, '.shop-by-spaces-hero__image', '.shop-by-spaces-hero', 1440);
            updatePricingForShopBySpaces(shopBySpacesHeroSection);
            renderShopBySpacesComposites(shopBySpacesHeroSection);
            updateTabStyling(shopBySpacesHeroSection);
            document.querySelectorAll('.shop-by-spaces-hero .shop-by-spaces-hero__tabs-button').forEach((button) => {
                button.addEventListener('click', handleShopBySpacesTabClick);
            });
            initSwipeOnTabsCarousel(shopBySpacesHeroSection)
        }

        let fromLoad = shopBySpacesHeroSection.closest('.homepage-content-container') && shopBySpacesHeroSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';

        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(shopBySpacesHeroSection);
        } else if(!shopBySpacesHeroSection.closest('.homepage-content-container')) {
            actionsOnVisible(shopBySpacesHeroSection);
        } else {
            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = shopBySpacesHeroSection.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

                if (
                    isVisible &&
                    shopBySpacesHeroSection.getAttribute("data-interacted") !== "true"
                ) {
                    actionsOnVisible(shopBySpacesHeroSection, parent);
                    shopBySpacesHeroSection.setAttribute("data-interacted", "true");
                    window.removeEventListener("scroll", scrollHandler);
                }
            };

            window.addEventListener("scroll", scrollHandler);
            }
        }

      // Exposed so the personalization re-init can re-measure the tabs after a client-side swap,
      // once the freshly-swapped slider/pagination has settled (otherwise the labels measure too
      // early and bunch — it self-corrects on resize, which also routes through updateTabStyling).
      window.Branch.shopBySpaces.updateTabStyling = updateTabStyling;

      window.Branch.shopBySpaces.initShopBySpaces = function(type){
        let uninitializedShopBySpacesSliders = document.querySelectorAll('.shopify-section.shop-by-spaces-hero:not([data-initialized="true"])');
        uninitializedShopBySpacesSliders.forEach((uninitializedShopBySpacesSlider) => {
            let parent = uninitializedShopBySpacesSlider.closest('.shopify-section');
            uninitializedShopBySpacesSlider.setAttribute('data-initialized', true);
            if(type == 'from-copy'){
                initshopBySpacesHero(uninitializedShopBySpacesSlider, parent, type)
            } else {
                window.Branch.functions.fireOnUserInteraction(initshopBySpacesHero, '.homepage-content-container', uninitializedShopBySpacesSlider, uninitializedShopBySpacesSlider, parent);
            }
        })
      }


    if (document.readyState === "complete") {
        window.Branch.shopBySpaces.initShopBySpaces('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.shopBySpaces.initShopBySpaces('regular'));
    }

    })();
